import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input
} from '@angular/core'
import { hlm } from '@spartan-ng/helm/utils'
import type { ClassValue } from 'clsx'

@Component({
  selector: 'hlm-sheet-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': '_computedClass()'
  },
  template: ` <ng-content /> `
})
export class HlmSheetHeader {
  public readonly userClass = input<ClassValue>('', { alias: 'class' })
  protected readonly _computedClass = computed(() =>
    hlm('flex flex-col gap-1.5 p-4', this.userClass())
  )
}
